import React, { useState } from 'react'
import { Table, Button, Badge, Alert, Spinner } from 'react-bootstrap'
import { useAdminPermissionValues, useDeleteAdminPermissionValue } from 'api/hooks/use-admin-permission-values'
import PermissionValueModal from './PermissionValueModal'

const PermissionValuesList = ({ permissionId }) => {
  const { data: values, isLoading, error } = useAdminPermissionValues({ permissionId })
  const deleteMutation = useDeleteAdminPermissionValue({ permissionId })
  const [showModal, setShowModal] = useState(false)
  const [editingValue, setEditingValue] = useState(null)

  const handleAdd = () => {
    setEditingValue(null)
    setShowModal(true)
  }

  const handleEdit = (value) => {
    setEditingValue(value)
    setShowModal(true)
  }

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this permission value?')) {
      deleteMutation.mutate(id)
    }
  }

  if (isLoading) {
    return (
      <div className="text-center p-3">
        <Spinner animation="border" size="sm" />
      </div>
    )
  }

  if (error) {
    return <Alert variant="danger">Error loading values: {error.message}</Alert>
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <strong>{values?.length || 0} Permission Values</strong>
        <Button variant="primary" size="sm" onClick={handleAdd}>Add Value</Button>
      </div>

      {values?.length > 0 ? (
        <Table bordered hover size="sm">
          <thead>
            <tr>
              <th>Value</th>
              <th>Value Caption</th>
              <th>Weight</th>
              <th>Conflict</th>
              <th>Expansive</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {values.map((val) => (
              <tr key={val.id}>
                <td>{val.value}</td>
                <td>{val.value_caption || '-'}</td>
                <td>{val.weight ?? '-'}</td>
                <td>{val.is_conflict ? <Badge bg="danger">Yes</Badge> : <Badge bg="secondary">No</Badge>}</td>
                <td>{val.is_expansive ? <Badge bg="warning">Yes</Badge> : <Badge bg="secondary">No</Badge>}</td>
                <td>
                  <Button variant="warning" size="sm" className="me-1" onClick={() => handleEdit(val)}>Edit</Button>
                  <Button variant="danger" size="sm" onClick={() => handleDelete(val.id)}>Delete</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Alert variant="info">No permission values yet.</Alert>
      )}

      <PermissionValueModal
        show={showModal}
        onHide={() => setShowModal(false)}
        permissionId={permissionId}
        permissionValue={editingValue}
      />
    </div>
  )
}

export default PermissionValuesList
